// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const HierarchySquare3Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "HierarchySquare3/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841Zm.183 6.525a3.618 3.618 0 0 1-3.408 2.425h-.017l-1.717-.009h-.008a1.4 1.4 0 0 0-1.35 1.034 1.83 1.83 0 0 1 1.283 1.741 1.839 1.839 0 0 1-1.833 1.834 1.839 1.839 0 0 1-1.833-1.834c0-.741.45-1.383 1.083-1.666V8.083A1.708 1.708 0 0 1 4.792 6.5 1.71 1.71 0 0 1 6.5 4.792 1.71 1.71 0 0 1 8.208 6.5a1.7 1.7 0 0 1-1.083 1.583v1.684a2.62 2.62 0 0 1 1.4-.409h.008l1.717.009c.983.033 1.858-.6 2.208-1.517a1.705 1.705 0 0 1-.675-1.35 1.71 1.71 0 0 1 1.709-1.708A1.71 1.71 0 0 1 15.2 6.5c.008.883-.667 1.6-1.525 1.692Z"
}));
export default HierarchySquare3Icon;